import classNames from "classnames"
import "./headerMenu.css"
import { Link, useLocation } from "wouter"
import { useWatcher } from "../../../lib/state/useWatcher"
import { userState } from "../../../store/user"
import { UserIcon } from "../../button/IconButton"
import { UserRole } from "src/types"
import { hasUserAccess } from "@/utils/user"
import { BellIcon } from "lucide-react"
import { useMessages } from "@/providers/MessagesProvider"
import styled from "styled-components"

const UnreadBadge = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  background: #8c5fec;
  color: #fff;
  min-width: 18px;
  height: 18px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #fff;
`

const items = [
  {
    label: "Mani uzdevumi",
    url: "/dashboard",
  },
  { label: "Admin", url: "/admin/dashboard", neededRole: UserRole.Manager },
  {
    label: <BellIcon fill="" width={20} height={20} />,
    url: "/notifications",
    icon: true,
  },
  { label: UserIcon, url: "/me", icon: true },
]

export const HeaderMenu = () => {
  const [location] = useLocation()
  const user = useWatcher(userState)
  const { unread } = useMessages()

  return (
    <div className="header-menu">
      <div className="items">
        {items.map((item) => {
          if (
            item.neededRole != null &&
            !hasUserAccess({
              neededRole: item.neededRole,
              userRole: user.role,
            })
          ) {
            return null
          }
          let label = item.label
          if (item.label === "Admin" && user.role === UserRole.Manager) {
            label = "Menedžeris"
          }

          const showBadge = item.url === "/notifications" && unread
          return (
            <Link to={item.url} key={item.url}>
              <div
                className={classNames(
                  "item",
                  location.startsWith(item.url) && "active",
                  item.icon && "is-icon",
                )}
              >
                {label}
                {showBadge ? <UnreadBadge>{unread}</UnreadBadge> : null}
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
